import React, {
  createContext,
  ReactNode,
  useContext,
} from 'react';
import isNil from 'lodash/isNil';

export type BaseTableContext = {
  refetch?: () => void;
};

const TableContext = createContext<unknown>(null);

type TableProviderProps<T> = {
  children: ReactNode;
  value: T;
};

export function TableProvider<T>({ children, value }: TableProviderProps<T>) {
  return (
    <TableContext.Provider value={value}>
      {children}
    </TableContext.Provider>
  );
}

export function useTableContext<T extends BaseTableContext>(): T {
  const context = useContext(TableContext);
  if (isNil(context)) {
    throw new Error('useTableContext must be used within a TableProvider');
  }
  return context as T;
}
